export default {
  'clocks': [
    'clock0800_1200',
    'clock1400_1600'
  ],
  'permanentRequiredFields': [
    'Salutation',
    'FirstName',
    'LastName',
    'RequestInterest',
    'Email'
  ],
  'requiredFields': {
    'consulting': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'cooperation': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'other': [
      'PostalCode'
    ]
  },
}
